
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '../../controlador';
    import { Controlador as Model } from './controlador';
    import { Categoria } from '@/__env/lib/Web/Categorias';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import listado from './categorias-listado.vue';
    import buscador from './categorias-buscador.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            listado,
        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public get Controlador() { return Vue.observable( Model ); }
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Nueva: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Controlador.Buscador.Filtros.set( this.$route.query );
            this.Controlador.Buscador.Buscar();

        }


        public async Atras()
        {
            if ( this.Controlador.Historial.hasRows() )
            {
                this.Controlador.Seleccionado = this.Controlador.Historial.pop();
                this.Buscador.Filtros.Padre = this.Controlador.Seleccionado.Id;
            } else
            {
                this.Controlador.Seleccionado = null;
                this.Buscador.Filtros.Padre = null;
            }

            this.Controlador.Filtrados.clear();
            await this.Buscador.Buscar();
        }


     

    }
